import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer'
  },

  titleRow: {
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      margin: '0 0.5rem 0 0',
      minWidth: '1rem',
      minHeight: '1rem'
    }
  },

  tags: {
    display: 'flex',
    alignItems: 'center',
    color: '#8F8F8F',
    fontSize: theme.size.sm,

    '& svg': {
      marginRight: '0.5rem',
      minWidth: '12px',
      minHeight: '12px'
    }
  },

  tag: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '0.5rem',

    '&:last-child': {
      marginRight: '0'
    }
  },

  user: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',

    '& [role="cell"]': {
      margin: '0 0.5ch'
    },

    '& *': {
      whiteSpace: 'nowrap'
    }
  },

  statusRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: theme.size.sm,

    '& svg': {
      marginRight: '0.5rem'
    }
  },

  statusBlock: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: '100rem',
    padding: '0.25rem 0.5rem',
    userSelect: 'none'
  },

  statusPublished: {
    backgroundColor: '#D2FFC7',
    color: '#5CC043'
  },

  statusUnpublished: {
    backgroundColor: '#F0F0F0',
    color: '#8F8F8F'
  },

  statusDraft: {
    backgroundColor: '#FFE5A3',
    color: '#D4A428'
  },

  controls: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem'
  },

  menu: {
    padding: '0'
  }
}))

export default useStyles
